import Vue from 'vue'
import App from './App.vue'
import router from './router'
import estado from './filters/estado'

Vue.config.productionTip = false

Vue.use(estado)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
